import { MdOutlineArrowDropDown } from "react-icons/md";
import { useEffect, useState } from "react";
import "../../css/ActionMenu.css";
import Spinner from "../Spinner";
import Dropdown from "./Dropdown";

const ActionMenu = ({
  title,
  options,
  onChangeHandler,
  actionMenuStyle,
  isLoading = false,
  dropdown = false,
  dropdownValue = null,
  dropdownOptions = {
    clearable: false,
    search: false,
    placeholder: "",
    label: "",
    multiple: false,
  },
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const closeDropdown = (event) => {
      if (!event.target.closest(".action-menu")) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  return (
    <>
      {dropdown ? (
        <Dropdown
          label={dropdownOptions.label}
          clearable={dropdownOptions.clearable}
          search={dropdownOptions.search}
          placeholder={dropdownOptions.placeholder}
          options={options}
          value={dropdownValue}
          onChange={onChangeHandler}
          multiple={dropdownOptions.multiple}
        />
      ) : (
        <div className="action-menu" style={actionMenuStyle} onClick={() => setIsOpen(!isOpen)}>
          <div>{isLoading ? <Spinner size="tiny" color="white" /> : title}</div>
          <MdOutlineArrowDropDown size={20} />

          {isOpen && (
            <div className="action-dropdown">
              {options.map((item, index) => (
                <li
                  className="action-dropdown-item"
                  key={index}
                  onClick={() => {
                    console.log(item);
                    onChangeHandler(item);
                  }}
                >
                  {item.text}
                </li>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ActionMenu;
